const breakpoints = {
  sm: window.matchMedia('(min-width: 480px)'),
  md: window.matchMedia('(min-width: 750px)'),
  lg: window.matchMedia('(min-width: 990px)'),
  xlg: window.matchMedia('(min-width: 1140px)'),
  x2lg: window.matchMedia('(min-width: 1400px)')
}

const mobileAccordions = document.querySelectorAll('[data-mobile-accordion]')

const toggleAccordions = (nodeList, show = false) => {
  nodeList.forEach(accordion => {
    if (show) {
      accordion.setAttribute('open', true)
      accordion.querySelector('summary').setAttribute('tabindex', '-1')
    } else {
      if (accordion.dataset.mobileOpen === 'true') {
        accordion.setAttribute('open', true)
      } else {
        accordion.removeAttribute('open')
      }

      accordion.querySelector('summary').removeAttribute('tabindex')
    }
  })
}

if (mobileAccordions.length) {
  toggleAccordions(mobileAccordions, breakpoints.md.matches)

  breakpoints.md.addEventListener('change', event => {
    toggleAccordions(mobileAccordions, event.matches)
  })
}
